import { createSlice } from "@reduxjs/toolkit";

import { IBlogStore } from "../types";

const initialState: IBlogStore = {
  blogs: [],
};

export const blogSlice = createSlice({
  name: "blog",
  initialState,
  reducers: {
    setBlogs: (state, { payload }) => {
      state.blogs = payload;
    },
  },
});

export const { setBlogs } = blogSlice.actions;
